import React from 'react';
import styles from '../guides/style.module.scss';
import CollapsibleSection from 'components/collapsible/collapsible-section';
import InsightsChart from './insights-chart';
import StatCard from './stat-card';
import formatCurrency from 'utils/format-currency';
import type { InsightsResponse } from '@zoocasa/go-search';

//#region Types
export type AreaListingsPageCollapsibleGuideProps = {
  isActive: boolean;
  title: string;
  className?: string;
  testId?: string;
  onCollapsibleSectionClick(): void;
  insightsData?: InsightsResponse;
};
//#endregion


export const AreaListingsPageMarketInsights = ({
  isActive,
  title,
  className,
  testId,
  onCollapsibleSectionClick,
  insightsData,
}: AreaListingsPageCollapsibleGuideProps) => {
  const medianPrice = insightsData?.MedianPurchasePrice ?? 0;
  const daysOnMarket = insightsData?.DaysOnMarket ?? 0;
  const avgPricePerSqft = insightsData?.AvgPricePerSqft ?? 0;

  return (
    <CollapsibleSection
      isActive={isActive}
      title={title}
      className={className}
      testId={testId}
      onClick={onCollapsibleSectionClick}
    >
      <div className={styles['stat-cards-container']}>
        <StatCard
          title="Median Home Price"
          formattedValue={formatCurrency(medianPrice)}
          showNotAvailable={medianPrice <= 0}
          tooltipContent="The price at which half the homes sold for more and half sold for less in the last 90 days"
          period="Past 90 days"
        />
        <StatCard
          title="Price per Sq.Ft"
          formattedValue={formatCurrency(avgPricePerSqft)}
          showNotAvailable={avgPricePerSqft <= 0}
          tooltipContent="The average price for each square foot of living space sold in the last 90 days"
          period="Past 90 days"
        />
        <StatCard
          title="Avg. Days on Market (DOM)"
          formattedValue={`${daysOnMarket} days`}
          showNotAvailable={daysOnMarket <= 0}
          tooltipContent="The average number of days a property was actively listed for sale before going under contract in the last 90 days"
          period="Past 90 days"
        />
      </div>
      <InsightsChart insightsData={insightsData} />
    </CollapsibleSection>
  );
};
